/**
 * Отзывы главной (02_GPT-MODULAR).
 */

export const GOOGLE_REVIEWS_URL = "https://www.google.com/search?q=tybe.nl+reviews";

export const LATEST_REVIEWS = [
    {
        name: "Pieter Janssen",
        date: "6 days ago",
        rating: 5,
        avatar: "/reviews/pieter.jpg",
        text: "Needed something for warehouse data, not another bloated CMS. They actually listened. Tool went live last Thursday — already saving us a couple of hours a day.",
    },
    {
        name: "Anna Schmidt",
        date: "2 weeks ago",
        rating: 5,
        avatar: "/reviews/anna.jpg",
        text: "Full shop rebuild. Filters finally work on a phone and checkout is less of a circus. Two small bugs after launch, both fixed the same day.",
    },
    {
        name: "John Williams",
        date: "3 weeks ago",
        rating: 4,
        avatar: "/reviews/john.jpg",
        text: "Telegram bot for support. Does what we asked. Took a bit longer than the first estimate, but they flagged it early instead of going silent. Solid.",
    },
    {
        name: "Marcus Lee",
        date: "1 month ago",
        rating: 5,
        avatar: "/reviews/marcus.jpg",
        text: "SaaS dashboard from scratch. Weekly calls, no jargon dumps. Code is readable, which is rare. We'll be back for the next module.",
    },
    {
        name: "Sofia Rossi",
        date: "1 month ago",
        rating: 5,
        avatar: "/reviews/sofia.jpg",
        text: "Landing page refresh. Bounce rate dropped and the form actually gets filled in now. They pushed back on a few of my ideas — page is better for it.",
    },
    {
        name: "David Chen",
        date: "2 months ago",
        rating: 5,
        avatar: "/reviews/david.jpg",
        text: "Nasty API integration hanging over us. They mapped the edge cases before writing a line of code and still hit the deadline. Docs were actually useful.",
    },
    {
        name: "Elena Müller",
        date: "2 months ago",
        rating: 5,
        avatar: "/reviews/elena.jpg",
        text: "Mobile-first app for our field team. Fast, doesn't feel like a website stuffed into a wrapper. Caught a few UX issues we hadn't thought about.",
    },
    {
        name: "James Okafor",
        date: "3 months ago",
        rating: 5,
        avatar: "/reviews/james.jpg",
        text: "Migrated a creaky PHP setup to a modern stack. Zero downtime, which I didn't fully believe until it happened. Handover notes were thorough.",
    },
    {
        name: "Yuki Tanaka",
        date: "3 months ago",
        rating: 5,
        avatar: "/reviews/yuki.jpg",
        text: "Realtime ops dashboard. Numbers update without refreshing and it looks sharp on the office TV. Easy team to work with, no chasing.",
    },
];

// config/reviews.js
